<!--
  -  Copyright (c) Qwoach LLC 2023. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 10/3/2023
  -->

<template>
	<el-autocomplete
		class="input-background w-100"
		v-bind="attrsNoListeners"
		:fetch-suggestions="onFetchSuggestions"
		:placeholder="placeholder"
		ref="autocomplete"
		@select="handleSelect"

	>

		<template #append>
			<slot name="append"></slot>
		</template>
		<template #default="{ item }">
			<slot name="default" :item="item">
				{{item}}
			</slot>
		</template>
	</el-autocomplete>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import {isFunction} from "@/utils/helpers";
let {classToClass} = require("@qwoach/class-transformer-wrapper")

export default {
	name: "QwAutocompleteExtended",
	extends: BaseComponent,
	inheritAttrs: false,

	props: {
		suggestions: [Array, Function],
		cacheSuggestions: Boolean,
		filterSuggestionsFn: Function,
		placeholder: {String, default: "type here"},
	},

	data() {
		return {
			cachedSuggestionsResult: null,
			suggestionsData: [],
		}
	},


	methods: {

		autocompleteBlur() {
			// need to listen for activated change to handle it properly
			// if(!this.$refs.saveTagInput.activated){
			//     this.handleInputConfirm()
			// }
		},

		// handleInputConfirm(suggestionsTag) {
		// 	console.log("handleInputConfirm: ", this.inputValue)
		// 	let inputValue = this.inputValue;
		// 	if (inputValue) {
		// 		// this.valueData.push(new TagItem(inputValue));
		// 		if (typeof inputValue === "string") {
		// 			inputValue = new TagItem(inputValue)
		// 			if(this.rotateColors){
		// 				let len = defaultColorPickerPalette.length
		// 				this.lastUsedColorIndex = (this.lastUsedColorIndex + 1) % len
		// 				inputValue.color = defaultColorPickerPalette[this.lastUsedColorIndex]
		// 			}
		// 			suggestionsTag = inputValue
		// 		}
		// 		if(this.assignRandomColor){
		// 			// let len = defaultColorPickerPalette.length
		// 			// inputValue.color = defaultColorPickerPalette
		// 		}
		// 		this.valueData.push(inputValue);
		// 		this.notifyValueChanged()
		// 		if (this.shouldOpenDetailsOnTagCreation) {
		// 			this.onTagClicked(inputValue, suggestionsTag)
		// 		}
		// 	}
		// 	this.closeSuggestions()
		// },


		handleSelect(item) {
			this.$emit("update:modelValue", item)
			this.$emit("select", item)
			// console.log("handleSelect: ", item)
			// this.selectWasClicked = true
			// this.inputValue = classToClass(item)
			// console.log(item);
			// this.handleInputConfirm(item)
		},


		async defaultFilterFn(query, array){
			// return array.filter(item => typeof item === "string" ? item.toLowerCase().indexOf(query.toLowerCase()) >= 0 : true)
			let queryStr = "" + query
			return array.filter(item =>("" + item).toLowerCase().indexOf(queryStr.toLowerCase()) >= 0)
		},

		async onFetchSuggestions(query, callback){
			let suggestionsArray
			if(isFunction(this.suggestions)){
				console.log("onFetchSuggestions: this.suggestions is function. Calling it")

				if(!this.cacheSuggestions || !this.cachedSuggestionsResult){
					this.cachedSuggestionsResult = await this.suggestions(query)
				}
				suggestionsArray = this.cachedSuggestionsResult
			} else if(Array.isArray(this.suggestions)){
				suggestionsArray = this.suggestions
			}

			if(suggestionsArray && suggestionsArray.length > 0){
				if(this.filterSuggestionsFnComputed && query){
					suggestionsArray = await this.filterSuggestionsFnComputed(query, classToClass(suggestionsArray))
				}
			}
			this.suggestionsData = suggestionsArray

			console.log("onFetchSuggestions: query = ", query, ", this.suggestionsData = ", this.suggestionsData)

			callback(this.suggestionsData)

		},

		showInput() {
			this.inputVisible = true;
			this.$nextTick(_ => {
				this.setFocusOnInput()
			});
		},
		setFocusOnInput() {
			this.$refs.autocomplete.$refs.inputRef.focus();
		},
	},
	computed: {
		filterSuggestionsFnComputed() {
			return this.filterSuggestionsFn || this.defaultFilterFn
		}
	},
}
</script>

<style lang="scss">

</style>
